import { Header } from "@/app/layout/Header";
import { Main } from "@/app/layout/Main";
import { dashboardLayout } from "../lib/dashboard-layout";
import { DashboardBottomPanels } from "../ui/DashboardBottomPanels";
import { DashboardHero } from "../ui/DashboardHero";
import { DashboardInbox } from "../ui/DashboardInbox";
import { DashboardManagementPanel } from "../ui/DashboardManagementPanel";
import { DashboardQuickActions } from "../ui/DashboardQuickActions";
import { DashboardShortcuts } from "../ui/DashboardShortcuts";
import { DashboardStandardsPanel } from "../ui/DashboardStandardsPanel";

export function DashboardPage() {
  return (
    <>
      <Header />

      <Main>
        <div className={dashboardLayout.pageStack}>
          <DashboardHero />

          <DashboardQuickActions />

          <DashboardInbox />

          {/* ສ່ວນສถิติ — ເຕັມຄວາມກວ້າງ ເພື່ອບໍ່ໃຫ້ກອດຊ້າຍ */}
          <DashboardStandardsPanel />
          <DashboardManagementPanel />

          <DashboardBottomPanels />

          <details
            className={`group rounded-xl border border-border bg-card/40 open:bg-card ${dashboardLayout.cardPad}`}
          >
            <summary className="cursor-pointer list-none font-semibold text-lg marker:content-none [&::-webkit-details-marker]:hidden">
              <span className="flex items-center justify-between gap-2">
                ເມນູເພີ່ມເຕີມ (Shortcuts)
                <span className="font-normal text-muted-foreground text-xs group-open:hidden">
                  ກົດເພື່ອເປີດ
                </span>
              </span>
            </summary>
            <div className="mt-4">
              <DashboardShortcuts />
            </div>
          </details>
        </div>
      </Main>
    </>
  );
}
